import { all, put, takeEvery, call, select } from "redux-saga/effects";
import {
  TRANSPORT_VOUCHERS_ACTIONS,
  TRANSPORT_VOUCHERS_TYPES
} from "./actions";
import {
  getTransportVoucher as APIgetTransportVoucher,
  getTransportVouchers as APIgetTransportVouchers,
  createTransportVoucher as APIcreateTransportVoucher,
  updateTransportVoucher as APIupdateTransportVoucher,
  deleteTransportVoucher as APIdeleteTransportVoucher
} from "../../services/api/transportVouchers";
import { navigateTo } from "../navigation/saga";
import { transportVouchersFilters } from "./selectors";

export function* watchTransportVouchersActions() {
  yield all([
    takeEvery(TRANSPORT_VOUCHERS_TYPES.LOAD_ALL_REQUEST, getTransportVouchers)
  ]);
  yield all([
    takeEvery(TRANSPORT_VOUCHERS_TYPES.LOAD_REQUEST, getTransportVoucher)
  ]);
  yield all([
    takeEvery(TRANSPORT_VOUCHERS_TYPES.CREATE_REQUEST, createTransportVoucher)
  ]);
  yield all([
    takeEvery(TRANSPORT_VOUCHERS_TYPES.UPDATE_REQUEST, updateTransportVoucher)
  ]);
  yield all([
    takeEvery(TRANSPORT_VOUCHERS_TYPES.DELETE_REQUEST, deleteTransportVoucher)
  ]);
  yield all([
    takeEvery(TRANSPORT_VOUCHERS_TYPES.CREATE_SUCCESS, getTransportVouchers)
  ]);
  yield all([
    takeEvery(TRANSPORT_VOUCHERS_TYPES.DELETE_SUCCESS, getTransportVouchers)
  ]);
  yield all([
    takeEvery(TRANSPORT_VOUCHERS_TYPES.UPDATE_FILTERS, getTransportVouchers)
  ]);
}

function* getTransportVouchers(action) {
  try {
    const filters = yield select(transportVouchersFilters);
    const transportVouchers = yield call(APIgetTransportVouchers, filters);
    yield put(TRANSPORT_VOUCHERS_ACTIONS.loadAllSuccess(transportVouchers));
  } catch (e) {
    yield put(TRANSPORT_VOUCHERS_ACTIONS.loadAllFailure(e));
  }
}

function* getTransportVoucher(action) {
  const { id } = action.payload;
  try {
    const transportVoucher = yield call(APIgetTransportVoucher, id);
    yield put(TRANSPORT_VOUCHERS_ACTIONS.loadSuccess(transportVoucher));
  } catch (e) {
    yield put(TRANSPORT_VOUCHERS_ACTIONS.loadFailure(e));
  }
}

function* createTransportVoucher(action) {
  const { values, redirect } = action.payload;
  try {
    const transportVoucher = yield call(APIcreateTransportVoucher, values);
    yield put(TRANSPORT_VOUCHERS_ACTIONS.createSuccess(transportVoucher));
    if (redirect) {
      yield call(
        navigateTo,
        "/admin/events/" + values.eventId + "/vouchers/transport"
      );
    } else {
      yield call(
        navigateTo,
        "/admin/events/" + values.eventId + "/vouchers/transport/create"
      );
    }
  } catch (e) {
    yield put(TRANSPORT_VOUCHERS_ACTIONS.createFailure(e));
  }
}

function* updateTransportVoucher(action) {
  const { id, values } = action.payload;
  try {
    const transportVoucher = yield call(APIupdateTransportVoucher, id, values);
    yield put(TRANSPORT_VOUCHERS_ACTIONS.updateSuccess(transportVoucher));
    yield call(
      navigateTo,
      "/admin/events/" + values.eventId + "/vouchers/transport"
    );
  } catch (e) {
    yield put(TRANSPORT_VOUCHERS_ACTIONS.updateFailure(e));
  }
}

function* deleteTransportVoucher(action) {
  const { id } = action.payload;
  try {
    const transportVoucher = yield call(APIdeleteTransportVoucher, id);
    yield put(TRANSPORT_VOUCHERS_ACTIONS.deleteSuccess(transportVoucher));
  } catch (e) {
    yield put(TRANSPORT_VOUCHERS_ACTIONS.deleteFailure(e));
  }
}
